import { Dialog } from "@reach/dialog";
import "@reach/dialog/styles.css";
import * as React from "react";
import { BsInstagram, BsTwitter, BsYoutube } from "react-icons/bs";
import { FaFacebook, FaLinkedin } from "react-icons/fa";
import { IMAGE_BASE_URL } from "../data/baseURL";

const DirectorsDetailsModal = ({
  userInfo,
  showDialog,
  close,
  text_1,
  text_2,
}) => {
  return (
    <div>
      <Dialog
        isOpen={showDialog}
        onDismiss={close}
        className="position-relative rounded-lg"
        aria-label="user-modal"
      >
        <div className="position-absolute end-0 top-0">
          {" "}
          <button className="border-0 rounded-lg" onClick={close}>
            <span aria-hidden className="fs-24 px-3 ">
              ×
            </span>
          </button>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-4 pt-1 mb-2 mb-sm-5">
          <div className="d-flex align-items-center mb-4 h-100">
            <img
              src={`${IMAGE_BASE_URL}/${userInfo?.image}`}
              loading="lazy"
              alt={userInfo?.name}
              style={{
                height: "100px",
                width: "100px",
                borderRadius: "50%",
                border: "0.3rem solid #f49807",
              }}
              className="img-fluid d-block"
            />
            <div className="fs-16 ms-5 d-none d-sm-block">
              <h2 className="fs-28">{userInfo?.name}</h2>
              <p className="gilroy-bold">{userInfo?.designation}</p>
              <a
                href={`mailto:${userInfo?.email}`}
                className="bg-american-yellow text-center text-white rounded fs-16 px-4 py-2 d-inline-block text-decoration-none gilroy-bold"
              >
                Contact
              </a>
            </div>
          </div>
          <div
            className=" h-100"
            // style={{ height: "150px", width: "150px" }}
          >
            <img
              src={`${IMAGE_BASE_URL}/${userInfo?.qr}`}
              alt="qr-code"
              className="img-fluid"
            />
          </div>
        </div>

        <div className="fs-16 px-3">
          <div className="fs-16 d-block d-sm-none mb-3 pb-1">
            <h2 className="fs-28">{userInfo?.name}</h2>
            <p className="gilroy-bold">{userInfo?.designation}</p>
            <a
              href={`mailto:${userInfo?.email}`}
              className="bg-american-yellow text-center text-white rounded fs-16 px-4 py-2 d-inline-block text-decoration-none gilroy-bold"
            >
              Contact
            </a>
          </div>
          <p className="text-orange-ryb gilroy-bold lh-40 my-0">{text_1}</p>
          <p
            className="text-align-justify"
            dangerouslySetInnerHTML={{ __html: userInfo?.skill_xperience }}
          />
          <p className="text-orange-ryb gilroy-bold lh-40 my-0">{text_2}</p>
          <p dangerouslySetInnerHTML={{ __html: userInfo?.appointment }} />
          <p dangerouslySetInnerHTML={{ __html: userInfo?.other }} />
          <div className="d-flex justify-content-end">
            <a
              href={userInfo?.fb}
              target="_blank"
              rel="noreferrer"
              className="mx-2"
            >
              <FaFacebook className="text-orange-ryb fs-24" />
            </a>
            <a
              href={userInfo?.linkenin}
              target="_blank"
              rel="noreferrer"
              className="mx-2"
            >
              <FaLinkedin className="text-orange-ryb fs-24" />
            </a>
            <a
              href={userInfo?.twitter}
              target="_blank"
              rel="noreferrer"
              className="mx-2"
            >
              <BsTwitter className="text-orange-ryb fs-24" />
            </a>
            <a
              href={userInfo?.instra}
              target="_blank"
              rel="noreferrer"
              className="mx-2"
            >
              <BsInstagram className="text-orange-ryb fs-24" />
            </a>
            <a
              href={userInfo?.youtube}
              target="_blank"
              rel="noreferrer"
              className="mx-2"
            >
              <BsYoutube className="text-orange-ryb fs-24" />
            </a>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default DirectorsDetailsModal;
